if (!customElements.get('results-exposed-filters')) {
  customElements.define(
    'results-exposed-filters',
    class ResultsExposedFilters extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.eventBus = window.theme.results.eventBus
        this.exposedNames = ['Price', 'Colour', 'UK Size', 'Size']
      }

      connectedCallback () {
        super.connectedCallback()

        this.onFacetsUpdated = ({ facets }) => {
          this.renderButtons(facets)
        }

        this.eventBus.subscribe(
          window.theme.results.events.STATE.FACETS_UPDATED,
          this.onFacetsUpdated,
        )
      }

      disconnectedCallback () {
        this.eventBus.unsubscribe(
          window.theme.results.events.STATE.FACETS_UPDATED,
          this.onFacetsUpdated,
        )
      }

      renderButtons (facets) {
        const available = this.exposedNames.filter(name =>
          facets.some(facet => facet.name === name),
        )

        this.innerHTML = available
          .map(
            name => `
          <button
            class="clc-ProductGridFacet_ExposedFilterButton"
            data-filter-key="${name}"
            data-drawers-trigger="mobile-results-filters"
            type="button"
          >
            ${name}
          </button>
        `,
          )
          .join('')

        this.querySelectorAll('button').forEach(button => {
          button.addEventListener('click', this.handleClick.bind(this))
        })
      }

      handleClick (event) {
        const filterKey = event.currentTarget.dataset.filterKey
        const drawer = document.querySelector('[key="mobile-results-filters"]')
        if (!drawer) return

        const facetItems = drawer.querySelectorAll('[data-filter-key]')

        facetItems.forEach(item => {
          const details = item.querySelector('details')
          if (!details) return

          if (item.dataset.filterKey === filterKey) {
            details.setAttribute('open', '')
          } else {
            details.removeAttribute('open')
          }
        })
      }
    },
  )
}
